import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import dayjs from 'dayjs';
import { uniq } from 'lodash';
import { getAdminWorkCalendarDataForProjectInTimeFrame } from 'scenes/WorkDemo/services/getAdminWorkCalendarDataForProjectInTimeFrame.service';
import { createRequestGetAdminWorkCalendarDataForProjectInTimeFrame } from 'scenes/WorkDemo/utils/requests/createRequestGetAdminCalendarDataInTimeframe';
import { returnMonthlySearchesTimeFrames } from 'scenes/WorkDemo/utils/returnMonthlySearchesTimeFrames.util';
import { loadAssignmentsForProjects } from 'store/assignments/thunks/loadAssignmentsForProjects';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { loadRecordAllowancesOfEmployerInTimeframe } from 'store/recordAllowances/thunks/loadRecordAllowancesOfEmployerInTimeframe.thunk';
import { createSignedRequest } from '../../utils/createSignedRequest';
import getCredentials from '../../utils/getCredentials';

export const loadAdminCalendarRecordsDataInTimeframe = createAsyncThunk(
  'workCalendar/loadAdminCalendarRecordsDataInTimeframe',
  async (_, { getState, dispatch }) => {
    const state = getState();

    const { workSearchParams_demo } = state;

    const selectedProjectId = selectSelectedProjectId(state);

    const fromDate = dayjs(workSearchParams_demo.fromDate);
    const toDate = dayjs(workSearchParams_demo.toDate);

    const searchMonthDifference = toDate.diff(fromDate, 'month');

    let recordsData = [];

    dispatch(
      loadRecordAllowancesOfEmployerInTimeframe({
        fromDate: workSearchParams_demo.fromDate,
        toDate: workSearchParams_demo.toDate,
      })
    );

    if (searchMonthDifference > 0) {
      const { accessKeyId, secretAccessKey, sessionToken } =
        await getCredentials();

      const monthlySearches = returnMonthlySearchesTimeFrames(fromDate, toDate);

      console.log('monthly searches', monthlySearches);

      const monthlyRecordsSearches = Promise.all(
        monthlySearches.map((monthlySearch) => {
          const request =
            createRequestGetAdminWorkCalendarDataForProjectInTimeFrame(
              selectedProjectId,
              monthlySearch.fromDate,
              monthlySearch.toDate
            );
          return createSignedRequest(
            request,
            accessKeyId,
            secretAccessKey,
            sessionToken
          );
        })
      );

      const [recordsSignedRequests] = await Promise.all([
        monthlyRecordsSearches,
      ]);

      const recordsRequestsPromises = Promise.all(
        recordsSignedRequests.map((request) =>
          axios(request).then((res) => res.data)
        )
      );

      const [recordsResponses] = await Promise.all([recordsRequestsPromises]);

      recordsData = {
        records: recordsResponses.map((response) => response.records).flat(),
      };
    } else {
      const recordsResponse =
        await getAdminWorkCalendarDataForProjectInTimeFrame(
          selectedProjectId,
          workSearchParams_demo.fromDate,
          workSearchParams_demo.toDate
        );

      const { records } = recordsResponse;

      recordsData = { records };
    }

    const calendarDataRecords = recordsData.records || [];

    const recordsProjectIds = uniq(
      calendarDataRecords
        .filter((record) => record.assignment)
        .map((record) => record.project)
    );

    dispatch(loadAssignmentsForProjects(recordsProjectIds));

    return recordsData;
  }
);
